import React from "react";
import Flex from "../Flex/Flex";
import Box from "../Box/Box";
import { SecondaryOutlinedButton } from "../Button/SecondaryButton";
import Icon from "../Icon/Icon";
import { H5 } from "../Text/Text";

const TagsCopyPaste = ({ handleChange, selectValues }) => {
  return (
    <Box>
      <Flex flexDirection="row-reverse" mt={1}>
        <SecondaryOutlinedButton
          onClick={(event) => {
            navigator.clipboard.readText().then((clipText) => {
              handleChange(JSON.parse(clipText));
            });
            event.preventDefault();
            event.stopPropagation();
          }}
          height="40px"
          borderRadius="8px"
        >
          <Flex justifyContent="center" alignItems="center" color="darkestShade">
            <Icon name="paste" />
            <H5 color="darkestShade">Paste</H5>
          </Flex>
        </SecondaryOutlinedButton>
        <SecondaryOutlinedButton
          onClick={(event) => {
            navigator.clipboard.writeText(JSON.stringify(selectValues));
            event.preventDefault();
            event.stopPropagation();
          }}
          height="40px"
          borderRadius="8px"
          mr={1}
        >
          <Flex justifyContent="center" alignItems="center" color="darkestShade">
            <Icon name="copy" />
            <H5 color="darkestShade">Copy all tags</H5>
          </Flex>
        </SecondaryOutlinedButton>
      </Flex>
    </Box>
  );
};

export default TagsCopyPaste;
